import Button from "components/Elements/Button/Button.js";
import React, { useState, useEffect } from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import FormBuilderEditOptionElement from "./FormBuilderEditOptionElement.js";

const FormBuilderEditOptions = ({
  field,
  optionsList,
  setOptionsList,
  setUpdateOptions,
  updateOptionsFunction,
}) => {
  const { getTextByKey } = useContent();
  const [isUpdateOptions, setIsUpdateOptions] = useState(false);

  const addOption = () => {
    let newOption = "";
    setOptionsList([...optionsList, newOption]);
  };

  const removeOption = (item) => {
    setOptionsList(optionsList.filter((option) => option !== item));
    setIsUpdateOptions(true);
  };

  useEffect(() => {
    if (field) {
      switch (field.template) {
        case "selectbasic":
          setOptionsList(field.fields.options);
          break;
        case "multipleradios":
          setOptionsList(field.fields.radios);
          break;
        case "multiplecheckboxes":
          setOptionsList(field.fields.checkboxes);
          break;
        case "recipientdropdown":
          setOptionsList(field.fields.options);
          break;
        default:
          break;
      }
    }
  }, [field]);

  useEffect(() => {
    if (isUpdateOptions) {
      updateOptionsFunction();
      setIsUpdateOptions(false);
    }
  }, [isUpdateOptions]);

  return (
    <div className="options-container">
      <div className="options-title">
        <p>{getTextByKey("options-title")}</p>
      </div>
      {optionsList && (
        <div className="options-list-container">
          {optionsList.map((item, i) => (
            <FormBuilderEditOptionElement
              item={item}
              key={i}
              i={i}
              updateOptionsFunction={updateOptionsFunction}
              optionsList={optionsList}
              setOptionsList={setOptionsList}
              removeOption={removeOption}
            />
          ))}
        </div>
      )}
      <div className="option-add">
        <Button onClick={() => addOption()}>
          {getTextByKey("add-option-button")}
        </Button>
      </div>
    </div>
  );
};

export default FormBuilderEditOptions;
